import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  const fieldMaxWidth = 250;

  return createStyles({
    formControl: {
      margin: theme.spacing(1),
      maxWidth: fieldMaxWidth
    },
    marginLeft: {
      marginLeft: theme.spacing(1)
    },
    isPrimarySwitch: {
      marginLeft: theme.spacing(2)
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    dialog: {
      overflow: 'hidden'
    },
    updateForm: {
      minWidth: 250,
      justifyContent: 'center'
    }
  });
});
